const hairColors = ['none', 'blonde', 'red', 'black', 'brown']
const bodyTypes = ['none', 'lean', 'big', 'normal', 'athletic']
const selectDefault = '-- Select --'
const adjectives = [
  'Alluring',
  'Seductive',
  'Handsome',
  'Irresistible',
  'Charming',
  'Attractive',
  'Captivating',
  'Magnetic',
  'Striking',
  'Dashing',
  'Hot',
  'Strong',
  'Awesome',
  'Big',
  'Muscle',
  'Sexy',
  'Gorgeous',
  'Sizzling',
  'Stunning',
  'Hunky',
  'Suave',
  'Masculine',
  'Fit',
  'Stylish',
  'Sophisticated',
  'Enchanting',
  'Desirable',
  'Exquisite',
  'Confident',
  'Alluring',
  'Dreamy',
]

const TRACKING_CONSTANTS = {
  DEFAULT_VIA: 'direct_link',
  PACKAGE_TYPES: {
    CREDITS: 'credits',
    GIFTS: 'gifts',
    SUBSCRIPTION: 'subscription',
    SPECIAL_OFFER: 'special_offer',
  },
  PLACES: {
    CREDITS_MODAL: 'credits_modal',
    PRICING_PAGE: 'pricing_page',
    INBOX_PAGE: 'inbox_page',
    CREDITS_PAGE: 'credits_page',
    GIFT_MODAL: 'gift_modal',
    PROFILE_PAGE: 'profile_page',
    MATCHES_PAGE: 'matches_page',
    FAVORITES_PAGE: 'favorites_page',
    VISITORS_PAGE: 'visitors_page',
    SETTINGS_PAGE: 'settings_page',
    PROFILES_PAGE: 'profiles_page',
    MATCH_GAME_PAGE: 'match_game_page',
    MEMBER_PRICING_PAGE: 'members_pricing_page',
    ABOUT_US_PAGE: 'about_us_page',
    FAQ_PAGE: 'faq_page',
    CONTACT_US_PAGE: 'contact_us_page',
    TERMS_AND_CONDITIONS_PAGE: 'terms_and_conditions_page',
    ANTI_HUMAN_TRAFFICKING_POLICY_PAGE: 'anti_human_trafficking_policy_page',
    NON_CONSENSUAL_PARTICIPATION_POLICY_PAGE:
      'non_consensual_participation_policy_page',
    PRIVACY_POLICY_PAGE: 'privacy_policy_page',
  },
  VIA: {
    INBOX_PAGE: 'inbox_page',
    FOOTER_LINK: 'footer_link',
    SIDEBAR: 'sidebar',
    FAVORITES_PAGE: 'favorites_page',
    VISITORS_PAGE: 'visitors_page',
    GIFT_DROPDOWN: 'gift_dropdown',
    GIFT_CONFIRM_MODAL: 'gift_confirm_modal',
    SPECIAL_OFFER_MODAL: 'special_offer_modal',
    CREDITS_MODAL: 'credits_modal',
    PROFILE_PAGE: 'profile_page',
  },
}

const MESSAGE_CONTEXT = {
  ALERT: 'alert',
}

const isAlertContext = context => context === MESSAGE_CONTEXT.ALERT

export {
  adjectives,
  bodyTypes,
  hairColors,
  isAlertContext,
  MESSAGE_CONTEXT,
  selectDefault,
  TRACKING_CONSTANTS,
}
